<template>
    <el-card>
        <div >{{editChose.roleName}}</div>
        <el-tree
      
        :data="menuTreeList"
        show-checkbox
        default-expand-all
        node-key="id"
        ref="tree"
        highlight-current
        :props="defaultProps"
        @check = "checkTree"
        >
        <span class="tree-node" slot-scope="{ data }">
        
            <span>{{ data.title }}({{ data.id }})</span>
            
          </span>
        </el-tree>
        <div style="margin-top: 20px" align="center" >
          <el-button type="primary" @click="handleSave(editChose.roleId)">保存</el-button>
          <el-button @click="handleClear()">清空</el-button>
          <el-button @click="returnback">返回</el-button>
          <!-- <el-button @click="setCheckedNodes">设置</el-button> -->
        </div>
      </el-card>
  </template>
  
  <script>
  
  import {  configureRoleMenus , authMenuList , getRoleMemus  } from '../../api/pemission.js'
    export default {
      name: "allocMenu",
      data() {
        return {
            editChose:{},
          menuTreeList: [],
          defaultProps: {
            children: 'children',
            label: 'title'
          },
          ids:[],
          roleId:null
        };
      },
      created() {
        this.getParams(this.$route.path)
          this.getdat2()
        this.editChose = JSON.parse(this.$route.query.role)
        // this.getRoleMenu(this.editChose.roleId)
  
       
      },
      methods: {
        checkTree(val){
            console.log(val)
            // let list = val
            // list.forEach(item => {
            //    console.log(item) 
            // });
        },
        returnback(){
            this.$router.push({path:'/system/role'})
              },
            
               // 配置角色菜单权限
        handleSave(roleId){
            let checkedNodes = this.$refs.tree.getCheckedNodes();
            let checkedMenuIds=new Set();
            if(checkedNodes!=null&&checkedNodes.length>0){
            for(let i=0;i<checkedNodes.length;i++){
                let checkedNode = checkedNodes[i];
                checkedMenuIds.add(checkedNode.id);
                if(checkedNode.parentId!==0){
                checkedMenuIds.add(checkedNode.parentId);
                }
            }
            }
            this.$confirm('是否分配菜单？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
            }).then(()=>{
            let params = new URLSearchParams();
            //   configureRoleMenus({menuIds,roleId}).then(res=>{
            //           console.log(res)
            //         })
            params.append("roleId",roleId);
            params.append("menuIds",Array.from(checkedMenuIds));
            configureRoleMenus(params).then(response => {
              if (response.code == '200') {
                this.$message({
                message: '分配成功',
                type: 'success',
                duration: 1000
                });
                this.$router.back();
              }else{
                // this.$message.error(response.data);
              }
               
            })
        })

               
                
              
              },
          handleCheckedCitiesChange(val){
          console.log(val)
        },
        setCheckedNodes() {
                console.log(this.menuTreeList)
                console.log(this.$refs.tree.setCheckedNodes)
                this.$refs.tree.setCheckedNodes([{
                    id: 2,
                    parentId: 1,
                    rule: "",
                    sort: null,
                    status: null,
                    systemId: null,
                    title: "aaa"
                }]);
            },

    getRoleMenu(roleId){
       
        getRoleMemus({roleId}).then(response=>{
          if(response.code==200){
            console.log(response)
          let menuList = response.data;
          let checkedMenuIds=[];
          if(menuList!=null&&menuList.length>0){
            for(let i=0;i<menuList.length;i++){
              let menu = menuList[i];
              if(menu.parentId!==0){
                checkedMenuIds.push(menu.id);
              }
            }
          }
          console.log(checkedMenuIds)
          this.$refs.tree.setCheckedKeys(checkedMenuIds);
        }
        });
      },
        getdat2() {
    
                authMenuList({start:0,length:20}).then(res=>{


                  
                    if (res.code == '200') {
                       
                        this.menuTreeList = res.data

                        // this.setCheckedNodes()
                        this.getRoleMenu(this.editChose.roleId)
                    }
                })
            },
      }
    }
  </script>
  
  <style scoped>
  .tree-node{
      width: 100px;
      display: flex;
      justify-content: space-between;
  }
  </style>
  